import React from 'react';
import { Card, Spin, Button, Empty, Badge, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface PanelCardProps {
  title: React.ReactNode;
  icon?: React.ReactNode;
  count?: number;
  loading: boolean;
  error: boolean;
  isEmpty: boolean;
  emptyText: React.ReactNode;
  onRetry: () => void;
  extra?: React.ReactNode;
  children: React.ReactNode;
}

const PanelCard: React.FC<PanelCardProps> = ({
  title, icon, count, loading, error, isEmpty, emptyText, onRetry, extra, children,
}) => {
  return (
    <Card
      title={
        <span>
          {icon} {title}{' '}
          {typeof count === 'number' && count > 0 && (
            <Badge count={count} style={{ backgroundColor: '#1890ff' }} />
          )}
        </span>
      }
      extra={extra}
      styles={{ body: { minHeight: 96 } }}
    >
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }} role="status" aria-label="Loading">
          <Spin />
        </div>
      ) : error ? (
        <div style={{ textAlign: 'center', padding: 16 }}>
          <Text type="danger">Couldn't load this panel.</Text>
          <div style={{ marginTop: 8 }}>
            <Button size="small" icon={<ReloadOutlined />} onClick={onRetry}>
              Retry
            </Button>
          </div>
        </div>
      ) : isEmpty ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
      ) : (
        children
      )}
    </Card>
  );
};

export default PanelCard;
